import { render, staticRenderFns } from "./SectionWithSimpleList.vue?vue&type=template&id=f6728c12&"
import script from "./SectionWithSimpleList.vue?vue&type=script&lang=js&"
export * from "./SectionWithSimpleList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports